import { Component } from '@angular/core';

@Component({
    selector: 'sr-login-error-sso-page',
    styleUrls: ['error-sso.component.scss'],
    templateUrl: 'error-sso.component.html',
    standalone: false
})
export class ErrorSSOPageComponent { }